import {Component, Input, OnInit, Output, EventEmitter, signal} from '@angular/core';
import { AppService } from 'src/app/app.service';
import {CoreModule} from "../../_core/core.module";

@Component({
  selector: 'app-banner-carousel',
	imports: [
		CoreModule
	],
  templateUrl: './banner-carousel.component.html',
  styleUrl: './banner-carousel.component.scss',
})
export class BannerCarouselComponent  implements OnInit {
	@Input() slides: any = [];
	@Input() viewItem;
	@Output() onBannerClick: any = new EventEmitter<{}>();

	slideIndex = signal(0);
	carouselSliding = signal(true);
	inhibitTimeout;


	constructor(
		private appService: AppService
	) { }

	ngOnInit() {
		if (this.viewItem) {
			const imageURL = this.viewItem.imageURL;
			if (imageURL) {
				this.slides.push({parsedUrl: imageURL });
			}
			this.viewItem._item.additionalImages?.forEach((image) => {
				if (image.url != imageURL){
					this.slides.push({ parsedUrl: image.url });
				}
			});
		}
		if (this.slides.length > 0) {
			setInterval(() => {
				if (this.carouselSliding()) {
					this.moveSlide(1);
				}
			}, 5000);
		}
	}

	moveSlide(op) {
		let newIndex = this.slideIndex() + op;
		if (newIndex < 0) newIndex = this.slides.length - 1;
		else if (newIndex > this.slides.length - 1) newIndex = 0;
		this.setSlide(newIndex);
	}

	setSlide (_index) {
		this.slideIndex.set(_index);
		clearTimeout(this.inhibitTimeout);
		this.carouselSliding.set(false);
		this.inhibitTimeout = setTimeout(() => {this.carouselSliding.set(true)}, 8000);
	}
	onMouseOver() {
		this.carouselSliding.set(false);
	}
	onMouseOut() {
		this.carouselSliding.set(true);
	}
	slideClick(_slide) {
		this.onBannerClick.emit(this.slides[this.slideIndex()]);
	}

}
